module.exports = __webpack_public_path__ + "img/correo 1.fd0b116d.svg";